module.exports = __webpack_public_path__ + "img/time-white.a12bd4c6.svg";